import PinIcon from "@/assets/iconComponent/PinIcon";
import type { FC, MouseEventHandler } from "react";

interface GxPinButtonProps {
  isPinned: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  size?: number;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
  disabled?: boolean;
}

const GxPinButton: FC<GxPinButtonProps> = ({
  isPinned,
  onClick,
  size = 10,
  activeColor = "#0A8442",
  inactiveColor = "#000000",
  className = "",
  // disabled = false,
}) => {
  return (
    <button
      type="button"
      // disabled={disabled}
      onClick={onClick}
      className={`gx-pin-icon ${
        isPinned ? "gx-pin-active" : "gx-pin-inactive"
      } ${className}`}
      aria-pressed={isPinned}
    >
      <PinIcon size={size} color={isPinned ? activeColor : inactiveColor} />
    </button>
  );
};

export default GxPinButton;